export class MasterPlanFilterType {
  id!: string;
  name!: string;
}
